import { Injectable, inject } from '@angular/core';
import { User } from '@app/model/user';
import { Notification } from '@app/model/notification';
import { SupabaseClient } from '@supabase/supabase-js';
import { Apply } from '@app/model/apply';
import { SUPABASE_CLIENT } from '@app/providers/supabase.provider';

@Injectable({
  providedIn: 'root'
})
export class ApplyService {

  user: User = new User('', '', '', '', '', '', '', 0, 0, 0, '', false, false, false, 0, '', '', '');
  notification: Notification = new Notification('', '', '', '', '', false, '', '');
  userId: any;
  allUserId: any[] = [];

  private supabaseClient: SupabaseClient;

  constructor() {
    this.supabaseClient = inject(SUPABASE_CLIENT);
  }

  async getAllCategoryApply() {
    return await this.supabaseClient.from('category_apply').select('*');
  }

  async getCategoryApplyByUserId(userId: string) {
    return await this.supabaseClient.from('category_apply').select('*').eq('create_from', userId);
  }

  async getCategoryApplyByApplyId(applyId: string) {
    return await this.supabaseClient.from('category_apply').select('*').eq('id', applyId);
  }

  async getUserIdByApplyId(applyId: string) {
    return await this.supabaseClient.from('category_apply').select('create_from').eq('id', applyId);
  }

  async getSubCategoryIdByApplyId(applyId: string) {
    return await this.supabaseClient.from('category_apply').select('apply_category').eq('id', applyId);
  }

  async createCategoryApply(apply: Apply) {
    const { error } = await this.supabaseClient.from('category_apply').insert({
      title: apply.title, description: apply.description, file_url: apply.file_url, create_from: apply.create_from, create_at: apply.create_at, apply_category: apply.apply_category
    });
    if (error) throw error;
  }

  async updateApplyStatus(applyId: string, status: string) {
    const { error } = await this.supabaseClient.from('category_apply').update({ status: status }).eq('id', applyId);
    if (error) throw error;
  }

  async clearApplyFileUrl(applyId: string) {
    const { error } = await this.supabaseClient.from('category_apply').update({ file_url: '' }).eq('id', applyId);
    if (error) throw error;
  }

  async sortCategoryApply(applies: Apply[]) {
    return applies.sort((a, b) => {
      const createAtA = new Date(a.create_at).getTime();
      const createAtB = new Date(b.create_at).getTime();
      return createAtA - createAtB;
    });
  }
}
